(function($){
    var __instances__ = {};

    function JavaAction (requestURL, dataSet, parser) {
        this._maxHistoryState = 2;

        this.state = [];
        this.requestURL = requestURL;
        this.dataSet = dataSet;
        this.parser = parser;
    }

    JavaAction.prototype = {
        getRequestURL: function () {
            return this.requestURL;
        },
        getDataSet: function () {
            return this.dataSet;
        },
        getData: function (data) {
            return this.getDataSet().apply(null, data);
        },
        getParser: function () {
            return this.parser;
        },
        parse: function (request, response, callback) {
            return this.getParser()(request, response, callback);
        },
        stringifyDataSet: function (args) {
            return JSON.stringify(this.getDataSet().apply(null, args));
        },
        updateState: function () {
            var date        = new Date(),
                state       = this.state,
                maxRequests = this._maxHistoryState;

            if (state.length >= maxRequests)
                state.pop();

            return state.unshift(date);
        },
        isDeprecatedRequest: function (request) {
            var state   = this.state,
                date    = request.date;

            return state[1] && date.isBefore(state[0]);
        },
        request: function (method, data, opts) {
            this.updateState();

            var self = this,
                sate = this.state,
                settings = Object.assign(opts || {}, {
                    type: method,
                    data: this.getData(data),
                    url: this.getRequestURL(),
                    date: moment(sate[0])
                }),
                ajax = $.ajax.call(this, settings),
                done = ajax.done;

            ajax.done = function (callback) {
                return done(function (response) {
                    return self.parse(settings, response, callback.bind(self));
                });
            };

            return ajax;
        },
        get: function (data, opts) {
            return this.request('GET', data, opts);
        },
        post: function (data, opts) {
            return this.request('POST', data, opts);
        },
        html: function (data, opts) {
            return this.request('HTML', data, opts);
        }
    };

    /**
     * Validation messages
     * @name messages
     * @memberof! JavaAction
     * @type {{}}
     */
    JavaAction.messages = {
        '000': DataForm.dataSets.message('000', 'OK'),
        '001': DataForm.dataSets.message(
            '001',
            'invalid_response',
            'Invalid response, something happened!',
            () => $.TextBundleUtil.getText('request.error.invalid_response')
        ),
        '002': DataForm.dataSets.message(
            '002',
            'invalid_dates_response',
            'Invalid response, could not retrieve dates marking!',
            () => $.TextBundleUtil.getText('request.error.invalid_dates_response')
        ),
        '003': DataForm.dataSets.message(
            '003',
            'invalid_months_response',
            'Invalid response, could not retrieve months marking!',
            () => $.TextBundleUtil.getText('request.error.invalid_months_response')
        ),
        '004': DataForm.dataSets.message(
            '004',
            'invalid_dest_response',
            'Invalid response, could not retrieve destinations!',
            () => $.TextBundleUtil.getText('request.error.invalid_dest_response')
        ),
        '005': DataForm.dataSets.message(
            '005',
            'invalid_dateEvents_response',
            'Invalid response, could not retrieve date events!',
            () => $.TextBundleUtil.getText('request.error.invalid_dateEvents_response')
        ),
        '006': DataForm.dataSets.message(
            '006',
            'invalid_subject_response',
            'Invalid response, could not retrieve subjects!',
            () => $.TextBundleUtil.getText('request.error.invalid_subject_response')
        ),
        '007': DataForm.dataSets.message(
            '007',
            'invalid_origin_response',
            'Invalid response, could not retrieve origins!',
            () => ''
        ),
    };

    $.RequestUtil = function (name, javaAction) {
        if (name in __instances__) {
            return __instances__[name];
        }

        return (__instances__[name] = javaAction);
    };

    $.RequestUtil('getCalendarData', new JavaAction(
        '/getCalendarData.do',
        function (CMCModule, departure, destination, destinationType, month, year, monthSpan, times, fromAbroadFlight, routeType) {
            return {
                packageSubType: CMCModule || 'searchPackage',
                departFrom: departure || 'TLV',
                destination: destination || 'ALL',
                chosenDestLocationType: destinationType || 'CITY',
                month: month || '',
                year: year || '',
                monthSpan: monthSpan || 1,
                times: times || jQuery.now(),
                fromAbroadFlight: fromAbroadFlight === true,
                isOneWay: routeType === 1
            };
        },
        function (req, res, callback) {
            if (res.trim() == '' || res.indexOf('ar1') == -1)
                return callback(JavaAction.messages['002'], req);

            return callback(JavaAction.messages['000'], req, $.DatesUtil.parseDatesResponse(res));
        }
    ));

    $.RequestUtil('getMonthCalendarData', new JavaAction(
        '/getMonthCalendarData.do',
        function (destination, destinationType, year, countryOrRegionCode, subjects) {
            year = year ? year.toString() : moment(Date.now()).format('YY');

            return {
                destination: destination || 'ALL',
                year: year.slice(-2),
                chosenDestLocationType: destinationType || 'CITY',
                countryOrRegionCode: countryOrRegionCode || '',
                subjects: subjects || ''
            };
        },
        function (req, res, callback) {
            if (res.trim() == '' || isNaN(parseInt(res[0])))
                return callback(JavaAction.messages['003'], req);

            res = res.trim().replace(/(\r\n|\n|\r)/gm," ");

            return callback(JavaAction.messages['000'], req, res.split(',', 12));
        }
    ));

    $.RequestUtil('getUIData', new JavaAction(
        '/renderUI.do',
        function (OMCModule, departure, destination, destinationType, departDate, returnDate, dateType, fromAbroadSearch, routeType) {
            if (!dateType || dateType === 'calendarDate' && departDate === '')
                dateType = 'unknown';

            return {
                data: "dest",
                module: OMCModule,
                firstDepartureDate: departDate || 0,
                firstReturnDate: returnDate || 0,
                chosenValue: dateType,
                chosenDate: dateType,
                chosenOrigin: departure,
                chosenDest: destination,
                chosenDestLocationType: destinationType || 'CITY',
                fromAbroadSearch: fromAbroadSearch === true,
                oneWayFlight: routeType === 1
            };
        },
        function (req, res, callback) {
            var parsed = $.parseJSON(res);

            if (!parsed.hasOwnProperty('locations'))
                return callback(JavaAction.messages['004'], req);

            if (!parsed.hasOwnProperty('dates'))
                return callback(JavaAction.messages['005'], req);

            if (!parsed.hasOwnProperty('originLocations'))
                return callback(JavaAction.messages['007'], req);

            (parsed.locations || {}).ALL = 'true';

            return callback(JavaAction.messages['000'], req, parsed);
        }
    ));

    window.JavaAction = JavaAction;
})($);